(() => {
  if (window.detailshopCollectionLoadMore) return;
  window.detailshopCollectionLoadMore = true;

  let loadMoreObserver;

  const observeLoadMore = (container) => {
    if (!container) return;

    // Start automatisch zodra de collectiepagina klaar is. De knop blijft als
    // toegankelijke fallback bestaan wanneer JavaScript of een request faalt.
    if (!container.dataset.autoLoadStarted) {
      container.dataset.autoLoadStarted = 'true';
      window.setTimeout(() => container.querySelector('[data-load-more-button]')?.click(), 120);
    }

    if (!('IntersectionObserver' in window)) return;

    if (!loadMoreObserver) {
      loadMoreObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.querySelector('[data-load-more-button]')?.click();
        });
      }, { rootMargin: '600px 0px' });
    }

    loadMoreObserver.observe(container);
  };

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-load-more-button]');
    if (!button) return;

    const container = button.closest('[data-collection-load-more]');
    const grid = document.querySelector('.collection-page .product-grid');
    const label = button.querySelector('[data-load-more-label]');
    const status = container?.querySelector('[data-load-more-status]');
    if (!container || !grid) return;
    const loadingLabel = container.dataset.loadMoreLoading || 'Loading products…';
    const moreLabel = container.dataset.loadMoreLabel || 'Load more products…';
    const loadedMoreTemplate = container.dataset.loadMoreStatusTemplate || '__COUNT__ more products loaded.';
    const errorLabel = container.dataset.loadMoreError || 'Products could not be loaded. Please try again.';
    const retryLabel = container.dataset.loadMoreRetry || 'Try again';

    event.preventDefault();
    if (button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = loadingLabel;

    try {
      const response = await fetch(button.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`Collection request failed with ${response.status}`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = documentFragment.querySelector('.collection-page .product-grid');
      const products = nextGrid ? [...nextGrid.children] : [];
      if (!products.length) throw new Error('No products found in the next collection page');

      products.forEach((product) => grid.append(product));

      const nextButton = documentFragment.querySelector('[data-load-more-button]');
      if (nextButton) {
        button.href = nextButton.href;
        delete container.dataset.autoLoadStarted;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        if (label) label.textContent = moreLabel;
        observeLoadMore(container);
      } else {
        loadMoreObserver?.unobserve(container);
        container.remove();
      }

      if (status) status.textContent = loadedMoreTemplate.replace('__COUNT__', products.length);
    } catch (error) {
      loadMoreObserver?.unobserve(container);
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      if (label) label.textContent = retryLabel;
      if (status) status.textContent = errorLabel;
    }
  });

  const loadMoreContainer = document.querySelector('[data-collection-load-more]');
  observeLoadMore(loadMoreContainer);
})();
